import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Skin {
  id: string;
  name: string;
  description: string;
  price: number;
  condition: string;
  type: string;
  category: string | null;
  weapon_type: string | null;
  preview_image: string;
  gallery_images: string[];
  created_at: string;
  updated_at: string;
}

export const useSkins = () => {
  return useQuery({
    queryKey: ["skins"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("skins")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data as Skin[];
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    gcTime: 1000 * 60 * 30, // Keep in garbage collection for 30 minutes
  });
};
